import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Navbar from './Components/Navbar';
import Home from './Components/Home';
import AboutUs from './Components/AboutUs';
import Service from './Components/Service';
import Hire from './Components/Hire';
import Blog from './Components/Blog';
import SingleBlogPost from './Components/SingleBlogPost';
import CaseStudy from './Components/CaseStudy';
import Portfolio from './Components/Portfolio';

// Global popups
import ExitIntentPopup from './Components/ExitIntentPopup';
import CallbackFormTrigger from './Components/CallbackFormTrigger'; // Floating CTA + Form

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />

        {/* Global popups */}
        <ExitIntentPopup />
        <CallbackFormTrigger /> {/* Left-center floating "Get a Call Back" button */}

       <Routes>
        <Route path="/CaseStudy" element={<CaseStudy />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<SingleBlogPost />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/Service" element={<Service />} />
        <Route path="/Hire" element={<Hire />} />
        <Route path="/portfolio" element={<Portfolio />} /> {/* ✅ Add this */}
        <Route path="/" element={<Home />} />
      </Routes>

      </BrowserRouter>
    </>
  );
}

export default App;
